import { render, staticRenderFns } from "./AreaRecommend.vue?vue&type=template&id=06d81e92&"
import script from "./AreaRecommend.vue?vue&type=script&lang=js&"
export * from "./AreaRecommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports